<fa-icon [icon]="faSpinner" size="2x" animation="spin"></fa-icon>
